import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { default as SM } from 'scrollmonitor';
import throttle from 'lodash/throttle';
import './Footer.css';

class Footer extends Component {
	constructor(props) {
		super(props);
		this.monitor_el = React.createRef();
		this.wrap_el = React.createRef();
		this.sizer_el = React.createRef();
		this.body_el = React.createRef();
		this.sensor_el = React.createRef();
		
		this.checkScroll = false;
		this.lastScrollPos = 0;
		this.mobileHidden = false;
		this.reachedTrigger = null;
		this.reachedBottom = null;
		this.revealed = false;
	}
	componentDidMount() {
		window.addEventListener('resize', this.throttledResize);
		window.addEventListener('scroll', this.throttledScroll);
		this.sm = SM.create( this.wrap_el.current, { bottom: -1 } );
		this.sm.on('stateChange', this.onStateChange);

		this.recalc();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.throttledResize);
		window.removeEventListener('scroll', this.throttledScroll);
		this.throttledResize.cancel();
		this.throttledScroll.cancel();
		this.sm.destroy();
	}
	recalc = () => {
		this.checkScroll = window.matchMedia("(max-width: 768px)").matches;
		this.full_h = this.body_el.current.clientHeight;
		this.sensor_h = this.sensor_el.current.clientHeight;
		this.viewport_h = SM.viewportHeight;
		this.sm.offsets.top = -this.sensor_h;
		this.sm.recalculateLocation();
		this.updateDOM();
	}
	onscroll = (e) => {
		const delta = SM.viewportTop - this.lastScrollPos;
		this.lastScrollPos = SM.viewportTop;
		
		if ( !this.checkScroll ) return;
		if ( this.revealed ) return;
		if ( this.reachedTrigger ) return;

		const wasHidden = this.mobileHidden;
		const buffer = 2500;
		this.mobileHidden = ( delta*delta > buffer ) ? (delta > 0) : wasHidden;
		
		if ( this.mobileHidden !== wasHidden ) this.updateDOM();
	}
	onStateChange = () => {
		this.reachedTrigger = this.sm.isInViewport;
		this.reachedBottom = this.sm.isFullyInViewport;
		this.revealed = ( this.reachedBottom )? false : this.revealed;
		if ( this.reachedTrigger || !this.checkScroll ) { this.mobileHidden = false; }

		this.updateDOM();
	}
	throttledResize = throttle( this.recalc, 100 )
	throttledScroll = throttle( this.onscroll, 100 )

	updateDOM = () => {
		const wrapEl = this.wrap_el.current;
		const sizerEl = this.sizer_el.current;
		
		wrapEl.style.height = this.full_h + 'px';
		wrapEl.classList.toggle('mobileHidden', (this.mobileHidden && this.checkScroll) ); 
		wrapEl.classList.toggle('reachedTrigger', this.reachedTrigger);
		wrapEl.classList.toggle('reachedBottom', this.reachedBottom);
		wrapEl.classList.toggle('revealed', this.revealed);

		const fixSizer = ( !this.reachedTrigger || this.revealed );
		if ( fixSizer ) {
			let sizer_h = this.revealed ? this.full_h : this.sensor_h;
			sizer_h = Math.min( sizer_h, this.viewport_h );
			sizerEl.style.position = 'fixed';
			sizerEl.style.bottom = 0;
			sizerEl.style.height = sizer_h + 'px';
		} else {
			sizerEl.removeAttribute('style');
		}
	}
	show = () => {
		this.revealed = true;
		this.updateDOM();
	}
	hide = (e) => {
		if ( e.relatedTarget !== window ) {
			this.lastScrollPos = SM.viewportTop;
			this.revealed = false;
			this.updateDOM();
		}
	}
	toggle = (e) => {
		if (this.revealed) { this.hide(e) } 
		else { this.show() }
	}
	onTouchEnd = (e) => {
		e.preventDefault()
		this.toggle(e);
	}

	render() {
		return (
			<footer className="Project-footer" ref={this.wrap_el}>
				<div className="Project-footer-sizer" ref={this.sizer_el}>
					<div className="Project-footer-sensor-bar" ref={this.sensor_el} onTouchEnd={this.onTouchEnd} onClick={this.toggle}>
						<div className="wrap">
							<h4><span className="icon-close">—</span><span className="text-close">Close</span></h4>
						</div>
					</div>
					<div className="Project-footer-body" ref={this.body_el}>
						<div className="wrap">
							<div className="Project-meta meta-tags">
								<h4>Tags</h4>
								<div className="links">
									<Links list={this.props.tags} base="tags" prepend="#" />
								</div>
							</div>
							<div className="Project-meta meta-related">
								<h4>Related</h4>
								<div className="links">
									<Links list={this.props.related} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		)
	}
}

export default Footer;

const Links = ({ list=[], base=null, prepend=null }) => {
	return list.map( (item, index) => {
		const href = (base)
			? '/' + base + '/' + item.slug
			: '/' + item.slug;

		const title = [item.title, item.row2].filter( val => (val !== null) ).join(' ');
		return <Link key={index} to={href}>{prepend}{title}</Link>
	} );
}


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Parts/Footer.jsx